import './lib';

import { ExtensionManager, MODULE_TYPES } from './extensions';
import { ServicesManager } from './services';
import classes, {
  CommandsManager,
  HotkeysManager,
} from './classes/';

import DICOMWeb from './DICOMWeb';
import DICOMSR from './DICOMSR';
import cornerstone from './cornerstone.js';
import log from './log.js';
import measurements from './measurements';
import metadata from './classes/metadata/';
import redux from './redux/';
import studies from './studies/';
import user from './user.js';
import errorHandler from './errorHandler.js';
import utils, { hotkeys, cacheManager } from './utils/';
import str2ab from './utils/str2ab';

import {
  UINotificationService,
  UIModalService,
  UIDialogService,
  MeasurementService,
  LoggerService,
} from './services';

const OHIF = {
  MODULE_TYPES,
  //
  CommandsManager,
  ExtensionManager,
  HotkeysManager,
  ServicesManager,
  //
  utils,
  hotkeys,
  cacheManager,
  studies,
  redux,
  classes,
  metadata,
  cornerstone,
  user,
  errorHandler,
  log,
  DICOMWeb,
  DICOMSR,
  viewer: {},
  measurements,
  //
  UINotificationService,
  UIModalService,
  UIDialogService,
  MeasurementService,
  LoggerService,
};

export {
  MODULE_TYPES,
  //
  CommandsManager,
  ExtensionManager,
  HotkeysManager,
  ServicesManager,
  //
  utils,
  hotkeys,
  cacheManager,
  studies,
  redux,
  classes,
  metadata,
  cornerstone,
  user,
  errorHandler,
  log,
  DICOMWeb,
  DICOMSR,
  measurements,
  //
  UINotificationService,
  UIModalService,
  UIDialogService,
  MeasurementService,
  LoggerService,
  str2ab,
};

export { OHIF };

export default OHIF;
